<div class="title-container">
  <!-- <h2>{{greeting}}<span>{{showUserName() | titlecase}}</span></h2> -->
  <!-- <h2>Dashboard</h2> -->
  <div class="userBtn-section" *ngIf="isMobile">
    <button class="td-btn deposit-btn" (click)="openDialogDeposit()">Depositar</button>
    <button class="td-btn withdrawal-btn" (click)="openDialogWithdraw()">Retirar</button>
  </div>
  <div class="userBtn-section" *ngIf="authService.loggedUser?.isCommerce && isMobile">
    <button class="td-btn charge-btn" routerLink="/charge/">
      Crear pago
      <img src="/assets/icons/lightning.svg" alt="lightning" />
    </button>
  </div>
  <div class="quick-buttons" *ngIf="isMobile">
    <!-- <button
      class="td-btn green quick-btn"
      (click)="toggleButtons(); $event.stopPropagation(); (false)"
    >
      Nueva operación <img class="icon" src="assets/icons/chevron-right-white.svg" alt="" />
    </button> -->
    <div class="separator"></div>
    <div
      class="quick-content"
      [class.hide]="showButtons === false"
      [class.show]="showButtons === true"
    >
      <a [routerLink]="['/core', 'change', 'solidario']"
        ><img class="icon" src="assets/icons/sidebar/Change-green.svg" alt="" />Dólares<img
          class="chevron"
          src="assets/images/right-chevron-black.svg"
          alt=""
      /></a>
      <a [routerLink]="['/core', 'investments']"
        ><img class="icon" src="assets/icons/sidebar/stock-green.svg" alt="" />Bolsa<img
          class="chevron"
          src="assets/images/right-chevron-black.svg"
          alt=""
      /></a>
      <a [routerLink]="['/core', 'crypto-exchange']"
        ><img class="icon" src="assets/icons/sidebar/crypto-green.svg" alt="" />Crypto<img
          class="chevron"
          src="assets/images/right-chevron-black.svg"
          alt=""
      /></a>
    </div>
  </div>
</div>
<!-- Withdrawals -->

<div class="container" *ngIf="!authService.loggedUser?.isCommerce" (click)="toggleButtons(false)">
  <!-- <app-alert-message></app-alert-message> -->

  <!-- <app-referral-alert-banner></app-referral-alert-banner> -->

  <app-onboarding></app-onboarding>
  <ng-container *ngIf="!authService.needToCompletedOnboarding()">
    <app-promotion-messages-carousel
      *ngIf="!data?.alertMessages?.message"
    ></app-promotion-messages-carousel>
  </ng-container>
  <app-main-balance
    [selectedTab]="selectedTab"
    (switchTab)="selectedTab = $event"
  ></app-main-balance>

  <app-detail-balance [selectedTab]="selectedTab"></app-detail-balance>
  <p class="footer-text">
    “SIXALIME S.A.S.- Proveedor de Servicios de Activos Virtuales (PSAV) inscripto bajo el N°21 de fecha 16 de mayo de 2024 en el Registro de Proveedores de Servicios de Activos Virtuales de CNV. Este registro es a los fines del control como Sujeto Obligado ante la Unidad de Información Financiera (UIF) y de todo otro ente regulador facultado a tal efecto, en el marco de sus competencias, y no implica licencia ni supervisión por parte de la COMISIÓN NACIONAL DE VALORES sobre la actividad realizada por el PSAV”.
  </p>
</div>

<app-commerce-dash *ngIf="authService.loggedUser?.isCommerce"></app-commerce-dash>
